/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountTaxMetric
 */
export interface AccountTaxMetric {
    /**
     * 
     * @type {string}
     * @memberof AccountTaxMetric
     */
    accountGuid: string;
    /**
     * 
     * @type {string}
     * @memberof AccountTaxMetric
     */
    accountType: string;
    /**
     * 
     * @type {number}
     * @memberof AccountTaxMetric
     */
    shortTermCapGainsTaxRate: number;
    /**
     * 
     * @type {number}
     * @memberof AccountTaxMetric
     */
    longTermCapGainsTaxRate: number;
    /**
     * 
     * @type {number}
     * @memberof AccountTaxMetric
     */
    taxBudget?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountTaxMetric
     */
    taxBudgetYear?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountTaxMetric
     */
    ytdStPnl?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountTaxMetric
     */
    ytdLtPnl?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountTaxMetric
     */
    ytdTax?: number;
}

/**
 * Check if a given object implements the AccountTaxMetric interface.
 */
export function instanceOfAccountTaxMetric(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "accountGuid" in value;
    isInstance = isInstance && "accountType" in value;
    isInstance = isInstance && "shortTermCapGainsTaxRate" in value;
    isInstance = isInstance && "longTermCapGainsTaxRate" in value;

    return isInstance;
}

export function AccountTaxMetricFromJSON(json: any): AccountTaxMetric {
    return AccountTaxMetricFromJSONTyped(json, false);
}

export function AccountTaxMetricFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountTaxMetric {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accountGuid': json['account_guid'],
        'accountType': json['account_type'],
        'shortTermCapGainsTaxRate': json['short_term_cap_gains_tax_rate'],
        'longTermCapGainsTaxRate': json['long_term_cap_gains_tax_rate'],
        'taxBudget': !exists(json, 'tax_budget') ? undefined : json['tax_budget'],
        'taxBudgetYear': !exists(json, 'tax_budget_year') ? undefined : json['tax_budget_year'],
        'ytdStPnl': !exists(json, 'ytd_st_pnl') ? undefined : json['ytd_st_pnl'],
        'ytdLtPnl': !exists(json, 'ytd_lt_pnl') ? undefined : json['ytd_lt_pnl'],
        'ytdTax': !exists(json, 'ytd_tax') ? undefined : json['ytd_tax'],
    };
}

export function AccountTaxMetricToJSON(value?: AccountTaxMetric | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account_guid': value.accountGuid,
        'account_type': value.accountType,
        'short_term_cap_gains_tax_rate': value.shortTermCapGainsTaxRate,
        'long_term_cap_gains_tax_rate': value.longTermCapGainsTaxRate,
        'tax_budget': value.taxBudget,
        'tax_budget_year': value.taxBudgetYear,
        'ytd_st_pnl': value.ytdStPnl,
        'ytd_lt_pnl': value.ytdLtPnl,
        'ytd_tax': value.ytdTax,
    };
}

